import { render, staticRenderFns } from "./MessList.vue?vue&type=template&id=6b1aea14&scoped=true&"
import script from "./MessList.vue?vue&type=script&lang=js&"
export * from "./MessList.vue?vue&type=script&lang=js&"
import style0 from "./MessList.vue?vue&type=style&index=0&id=6b1aea14&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1aea14",
  null
  
)

export default component.exports